<template>
    <div ref="tableRow" class="vs-table-row" :class="{'selected': selected, 'loading': isLoading}" style="position: relative;">
        <div ref="loadingOverlay" class="loading-overlay" v-if="isLoading">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div class="vs-table-rows-container" :class="{'pointer-cursor': getOptionValue('clickableRows')}">
            <div v-if="getOptionValue('hasActions')" class="vs-table-row-item justify-content-center align-items-center">
                <button v-if="options.access && options.access.edit && componentMode === 'view' && getOptionValue('isPrintable') === true" @click="onPrintClicked" class="btn btn-secondary ml-1"><i class="fa fa-print"></i></button>
                <button v-if="options.access && options.access.edit && componentMode === 'view' && getOptionValue('isEditable') === true" @click="onEditClicked" class="btn btn-secondary ml-1"><i class="icon-bd-pencil"></i></button>
                <!--<button v-if="showPaste" class="btn btn-secondary" @click="onPasteClicked"><i class="fa fa-paste pt-1"></i></button>-->
                <button v-if="options.access && options.access.delete && componentMode === 'view'" @click="onDeleteClicked" class="btn ml-1" :class="{'btn-secondary': deleteButtonState === 'primary', 'btn-danger': deleteButtonState === 'final'}"><i class="icon-bd-delete"></i></button>
                <button v-if="componentMode === 'edit' && getOptionValue('hasActionsInHeader')" @click="onEditConfirmedClicked" class="btn btn-secondary"><i class="icon-bd-check"></i></button>
                <button v-if="componentMode === 'edit' && getOptionValue('hasActionsInHeader')" @click="onCancelClicked" class="btn btn-secondary"><i class="icon-bd-close"></i></button>
            </div>
            <div v-for="(item, index) in headers" :key="index" class="vs-table-row-item" :class="setRowAlignment(item)" data-header="Header1" @click="onRowClicked(item)" @dblclick="onRowDoubleClicked(item)" :style="{'flex-grow': item.grow || 1}">
                <div v-if="item.type === 'text' || item.type === 'number'" class="d-flex" :style="{'flex': item.flex || ''}"><vs-input class="d-flex" :style="{'flex': item.flex || ''}" @dataChanged="onDataChanged" :data="row[index]" :header="item" :headerKey="index" :mode="item.mode||componentMode" :placeholder="item.title + ' را وارد کنید'" :type="item.type" :options="options" /></div>
                <div v-else-if="item.type === 'rowIndex'" class="d-flex" :style="{'flex': item.flex || ''}"><vs-input class="d-flex" :style="{'flex': item.flex || ''}" @dataChanged="onDataChanged" :data="rowIndex" :header="item" :headerKey="index" :mode="item.mode||componentMode" :placeholder="item.title + ' را وارد کنید'" :type="item.type" :options="options" /></div>
                <div v-else-if="item.type === 'price'" class="d-flex" :style="{'flex': item.flex || ''}"><vs-input class="d-flex" :style="{'flex': item.flex || ''}" @dataChanged="onDataChanged" :data="row[index].toLocaleString()" :header="item" :headerKey="index" :mode="item.mode||componentMode" :placeholder="item.title + ' را وارد کنید'" :type="item.type" :options="options" /></div>
                <div v-else class="d-flex" :style="{'flex': item.flex || ''}"><component class="d-flex" :style="{'flex': item.flex || ''}" @dataChanged="onDataChanged" @toggleInnerBox="onToggleInnerBox" :is="item.component" :row="row" :data="row[index]" :header="item" :headerKey="index" :mode="item.mode||componentMode" :options="options" /></div>
            </div>
        </div>
        <div class="vs-table-bottom-row-box hidden normal-inner-table-padding" v-if="options !== undefined && options.innerBox !== undefined && options.innerBox !== null">
            <vs-table v-if="options.innerBox.component === undefined" ref="table" :params="options.innerBox.params" :options="getOptionValue('innerBox.options')"></vs-table>
            <component v-else :is="options.innerBox.component" :row="row" />
        </div>
    </div>
</template>

<script>
import VsInput from "./VsInput.vue";
import VsSelect from "./VsSelect.vue";
import * as $ from "jquery";
import VsTableMixin from "./VsTableMixin";
import { mapState } from "vuex";
import EventBus from "./bus.js";

export default {
  name: "vs-table-row",
  components: {
    VsInput,
    VsSelect
  },
  props: ["row", "rowIndex", "headers", "options", "optionDefaults", "entity" , "showPaste"],
  data() {
    return {
      selected: false,
      input: {},
      showInnerBox: false,
      isLoading: false,
      deleteButtonState: "primary",
      componentMode: "view",
      // showPaste:false,
      // headers:[],
      // optionDefaults:null,
    };
  },
  mixins: [VsTableMixin],
  mounted() {
    EventBus.$on("onDeselect", () => {
      this.selected = false;
    });
    // console.log(this.options);
    // console.log(this.headers);
    // console.log(this.optionDefaults);
    EventBus.$on("onRowToggleLoadingView", id => {
      if (this.row.id !== id) {
        return;
      }

      this.isLoading = !this.isLoading;
    });

    EventBus.$on("onResetRowMode", () => {
      if (this.componentMode === "edit") {
        this.componentMode = "view";
      }
    });
  },
  methods: {
    setRowAlignment(header) {
      if (header.rowAlignment !== undefined && header.rowAlignment != null) {
        return header.rowAlignment;
      }

      return "";
    },
    onEditClicked() {
      if (this.options.onEditClicked) {
        this.$emit("onEditClicked", this.row);
      } else {
        this.onToggleEdit();
      }
    },
    onPrintClicked() {
      if (this.options.onEditClicked) {
        this.$emit("onPrintClicked", this.row);
      }
    },
    onPasteClicked() {
      if (this.options.onPasteClicked) {
        this.$emit("onPasteClicked", this.row);
      } else {
        this.onToggleEdit();
      }
    },
    onEditConfirmedClicked() {
      let updatedData = Object.assign({}, this.row, this.input);
      this.$emit("onUpdateEntityRequested", updatedData);
    },
    onDeleteClicked() {
      this.input = this.row;

      if (this.deleteButtonState === "primary") {
        this.deleteButtonState = "final";
        setTimeout(() => {
          this.deleteButtonState = "primary";
        }, 2000);
        return;
      } else if (this.deleteButtonState === "final") {
        this.$emit("onDelete", this.input);
        return;
      }
    },
    onToggleEdit() {
      if (this.componentMode === "edit") {
        this.componentMode = "view";
      } else {
        this.componentMode = "edit";
      }
    },
    onCancelClicked() {
      this.onToggleEdit();
    },
    onDataChanged(property, value) {
      this.$set(this.input, property, value);
    },
    onToggleInnerBox() {
      this.showInnerBox = !this.showInnerBox;
    },
    onRowClicked(header) {
      if (this.options.clickableRows && this.componentMode === "view") {
        if (
          header.triggersRowClickEvent === undefined ||
          header.triggersRowClickEvent === true
        ) {
          this.$emit("rowClicked", this.row);
        }

        this.$store.commit("SET_SELECTED_ROW", {
          row: this.row,
          key: this.entity
        });
        this.deselectAllRows();
        this.selected = true;
      }
    },
    onRowDoubleClicked(header) {
      if (this.options.clickableRows && this.componentMode === "view") {
        if (
          header.triggersRowClickEvent === undefined ||
          header.triggersRowClickEvent === true
        ) {
          this.$emit("rowDoubleClicked", this.row);
        }
      }
    },
    deselectAllRows() {
      EventBus.$emit("onDeselect");
    }
  },
  watch: {
    showInnerBox() {
      let self = this;
      setTimeout(function() {
        $(self.$el.parentElement)
          .children(".vs-table-row:not(.selected)")
          .find(".vs-table-bottom-row-box")
          .each(function(index) {
            $(this).slideUp(200);
          })
          .promise()
          .done(function() {
            $(self.$el)
              .children(".vs-table-bottom-row-box")
              .slideToggle(200);
            if (self.options.innerBox.component === undefined) {
              self.$refs.table.onFetchEntityListRequested({});
            }
          });
      }, 80);
    }
  },
  computed: {
    ...mapState(["selectedRows"])
  }
};
</script>

<style scoped lang="scss">
button i {
  font-size: 1.1rem;
}

button {
  height: fit-content;
}

.normal-inner-table-padding {
  display: block;
  padding: 2% 5%;
}

.hidden {
  display: none;
}

.loading-overlay {
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

@import "./VsTable.scss";
</style>
